var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_vm._v(" "),_c('div',{ref:"editor"})])}
var staticRenderFns = []

export { render, staticRenderFns }